// extracted by mini-css-extract-plugin
export default {"base":"Busy_base__PvMum","loader":"Busy_loader__POKXD","stripeMove":"Busy_stripeMove__xcnLV"};